"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartBadge = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var IconBadge_1 = require("../IconBadge/IconBadge");
require("./SmartBadge.css");
var SmartBadge = function (_a) {
    var _b = _a.clickable, clickable = _b === void 0 ? true : _b, i18n = _a.i18n;
    var _c = (i18n || {}).title, title = _c === void 0 ? 'Smart' : _c;
    return (react_1.default.createElement(IconBadge_1.IconBadge, { icon: "smart-wearable", className: (0, classnames_1.default)('dui-smart-badge', { clickable: clickable }), text: title }));
};
exports.SmartBadge = SmartBadge;
